import React, { useState } from 'react'
import AnalysisDashboard from './pages/AnalysisDashboard'
import LandingPage from './pages/LandingPage'
import PropertiesPage from './pages/PropertiesPage'
import LandlordReport from './pages/LandlordReport'
import Portfolio from './pages/Portfolio'

function App() {
  const [currentView, setCurrentView] = useState('landing')
  const [selectedProperty, setSelectedProperty] = useState(null)
  const [detailsUnavailable, setDetailsUnavailable] = useState(false)
  const [landlordReportState, setLandlordReportState] = useState(null) // { analysisId, premium }

  const startAnalysis = (propertyKey, options = {}) => {
    setSelectedProperty(propertyKey)
    setDetailsUnavailable(Boolean(options.detailsUnavailable))
    setCurrentView('analysis')
  }

  const goToMap = () => {
    setCurrentView('map')
  }

  const goToPortfolio = () => {
    setCurrentView('portfolio')
  }

  const goBack = () => {
    setCurrentView('landing')
    setSelectedProperty(null)
    setDetailsUnavailable(false)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {currentView === 'landing' && (
        <LandingPage
          onStartAnalysis={startAnalysis}
          onViewMap={goToMap}
          onViewPortfolio={goToPortfolio}
        />
      )}
      {currentView === 'portfolio' && (
        <Portfolio onBack={goBack} />
      )}
      {currentView === 'analysis' && (
        <AnalysisDashboard
          propertyKey={selectedProperty}
          detailsUnavailable={detailsUnavailable}
          onBack={goBack}
          onOpenLandlordReport={(analysisResult, premium = false) =>
            setLandlordReportState({ analysisResult, premium })
          }
        />
      )}
      {currentView === 'map' && (
        <PropertiesPage />
      )}

      {/* Landlord report overlay — rendered on top of any view */}
      {landlordReportState && (
        <LandlordReport
          analysisResult={landlordReportState.analysisResult}
          premium={landlordReportState.premium}
          onClose={() => setLandlordReportState(null)}
        />
      )}
    </div>
  )
}

export default App
